import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiTextField(_theme: Theme): MuiThemeComponentOverride<"MuiTextField"> {
  return {
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },
  };
}
